import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export const isPhoneDevice = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
const fmt = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

let active = null;

// Live call status. Android does not tell apps when an outgoing call is answered, so the desktop shows
// "call in progress" while the phone is on the call and then the real talk time (counted from pickup) from the call log.
function watch(id, label) {
  const tid = `call-${id}`;
  if (active) { clearInterval(active.t); clearInterval(active.tick); toast.dismiss(active.tid); }
  let n = 0, startedAt = 0, ended = false;
  const stop = () => { ended = true; clearInterval(t); clearInterval(tick); };
  const tick = setInterval(() => {
    if (!startedAt || ended) return;
    toast.loading(`Call in progress with ${label}`, { id: tid, description: "Ringing or talking on your phone. Talk time (counted from pickup) appears when the call ends." });
  }, 1000);
  const poll = async () => {
    n += 1;
    try {
      const { data } = await api.get(`/mobile/call-requests/${id}`);
      if (data.status === "dispatched") toast.loading(`Calling ${label} on your phone…`, { id: tid });
      if (data.status === "dialing" && !startedAt) { startedAt = Date.parse(data.dialed_at || "") || Date.now(); }
      if (data.status === "ended" && !ended) {
        ended = true; clearInterval(tick);
        toast.loading(`Call with ${label} ended`, { id: tid, description: "Reading talk time from your phone…" });
      }
      if (data.status === "completed") {
        stop();
        toast.success(`Call with ${label} ended · ${data.answered === false && !data.duration ? "not answered" : `talk time ${fmt(data.duration || 0)}`}`, { id: tid, description: "Saved in the CRM", duration: 8000 });
      }
      if (["failed", "cancelled"].includes(data.status)) { stop(); toast.error(`Call to ${label} ${data.status}`, { id: tid }); }
      if (data.status === "superseded") { stop(); toast.dismiss(tid); }
      if (data.status === "pending" && n > 90) { stop(); toast.error("Your phone did not pick up the call request. Is the OHC CRM app open?", { id: tid }); }
      if (data.status === "ended" && n > 60 && !data.duration) { stop(); toast.success(`Call with ${label} ended`, { id: tid }); }
    } catch { stop(); }
    if (n > 1800) { stop(); toast.dismiss(tid); }
  };
  const t = setInterval(poll, 1000);
  active = { t, tick, tid };
}

// Desktop: rings the user's paired phone. Phone (browser or app): opens the dialer directly.
export async function callViaPhone({ phone, name = "", entity_type = "", entity_id = "" }) {
  if (!phone) { toast.error("No phone number"); return "none"; }
  if (isPhoneDevice()) { window.location.href = `tel:${phone}`; return "local"; }
  try {
    const { data } = await api.post("/mobile/call", { phone, name, entity_type, entity_id });
    toast.loading(`Sending call to ${data.device_name}…`, { id: `call-${data.id}` });
    watch(data.id, name || phone);
    return "phone";
  } catch (e) {
    toast.error(formatApiError(e.response?.data?.detail), { action: { label: "Pair phone", onClick: () => { window.location.href = "/my-phone"; } } });
    return "none";
  }
}
